<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row q-col-gutter-md">
        <div class="col-8">
          <q-card>
            <q-card-section class="bg-primary text-white">
              <div class="row">
                <div class="text-h6 q-my-none">Goals</div>
                <q-space />
                <q-input
                  dark
                  standout
                  v-model="search"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"> </q-icon>
                  </template>
                </q-input>
              </div>
            </q-card-section>
            <div class="row">
              <div class="col-12 mt-0 pt-0" style="height: calc(100vh - 195px)">
                <datatable
                  style="height: 77vh"
                  :filter="search"
                  :flat="true"
                  :data="goals"
                  :columns="columns"
                  @rowDoubleClick="handleDoubleClick"
                >
                </datatable>
              </div>
            </div>
          </q-card>
        </div>
        <div class="col-4">
          <goalForm></goalForm>
        </div>
      </div>
    </div>

    <q-dialog v-model="viewDetailsDialog" seamless>
      <q-card
        v-if="viewDetailsDialog"
        tile
        style="
          width: 90vw !important;
          max-width: 95vw;
          height: 90vh;
          max-height: 95vh;
        "
      >
        <q-card-section class="bg-primary text-white q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">Outcome</div>
            <q-space />
            <q-btn
              color="white"
              round
              flat
              icon="mdi-close"
              @click="viewDetailsDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <!-- <outcomeForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          /> -->
          <goalForm
            ref="editForm"
            :data="viewFormData"
            @close="viewDetailsDialog = false"
            @loadingStateChanged="(state) => (saveLoading = state)"
          />
        </q-card-section>
        <q-card-section>
          <div class="row">
            <div class="col-12">
              <q-btn
                @click="$refs.editForm.save()"
                :loading="saveLoading"
                text
                color="primary"
                class="float-right"
                icon="mdi-content-save-all"
                label="Save"
              >
              </q-btn>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
// import outcomeForm from "@/components/outcomes/outcomeForm.vue";
import goalForm from "@/components/goals/goalForm.vue";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    goalForm,
    // outcomeForm,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      goals: "goals/list",
      goalsLoading: "goals/listLoading",
      // outcomes: "outcomes/list",
      // outcomesLoading: "outcomes/listLoading",
    }),
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "name",
        label: "Name",
        align: "left",
        field: "goal",
        sortable: true,
      },
      // {
      //   name: "name",
      //   label: "Name",
      //   align: "left",
      //   field: "name",
      //   sortable: true,
      // },
      // {
      //   name: "status",
      //   label: "Status",
      //   align: "left",
      //   field: "status",
      //   sortable: true,
      // },
      // {
      //   name: "created_by",
      //   label: "Created By",
      //   align: "left",
      //   field: "created_by",
      //   sortable: true,
      // },
      // {
      //   name: "updated_by",
      //   label: "Updated By",
      //   align: "left",
      //   field: "updated_by",
      //   sortable: true,
      // },
      // {
      //   name: "created_at",
      //   label: "Created At",
      //   align: "left",
      //   field: "created_at",
      //   format: (val) =>
      //     val != null
      //       ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
      //       : "",
      //   sortable: true,
      // },
      // {
      //   name: "updated_at",
      //   label: "Updated At",
      //   align: "left",
      //   field: "updated_at",
      //   format: (val) =>
      //     val != null
      //       ? moment.utc(val).local().format("DD-MMM, YYYY h:mma")
      //       : "",
      //   sortable: true,
      // },
    ],
    search: "",

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,
  }),
  beforeCreate() {
    // this.$store.dispatch("outcomes/loadAll");
    this.$store.dispatch("goals/loadAll");
  },
  mounted() {},
  methods: {
    handleDoubleClick(row) {
      // this.viewFormData = row;
      // this.viewDetailsDialog = true;
      this.$router.push("/solutionsDatabase/" + row.id);
    },
  },
};
</script>

<style scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}
</style>
